
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch, } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Collapse from '@/components/paragraphColl.vue'
import Nodata from '@/components/page/nodata.vue'
import f10ApiHk from '@/api/f10ApiHk'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
  },
  components: { Collapse, Nodata },

  setup(props, context) {
    const pageData: any = reactive({
      spinning: true,
      str: ''
    })
    onMounted(() => {
      const route: any = useRoute()
      const data: any = {}
      // data.data = {
      //   market: 'HK' || route.query.market,
      //   symbol: '00700' || route.query.symbol,
      //   mangeType: '1',
      //   mangeYear:'1'
      // }
      // data.headers = {
      //   token: '3d5eff0d3c7ac7f3af30c337dcdf6944' || props.token
      // }

      // f10ApiHk.getBriefBriefManagement(data).then((res: any) => {
      //   console.log('我是主营介绍', res.data)

      // })


      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700',

      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }

      f10ApiHk.getBriefDetail(data).then((res: any) => {
        console.log('我是主营介绍', res.data?.companyInfoDetail.orgCnIntroduction)
        if (res) {
          pageData.str = res.data?.companyInfoDetail.orgCnIntroduction
          pageData.spinning = false
        }

      })

    })
    // watch(
    //   () => (props.pageSourceData || {}).BusinessProfile,
    //   (val: any) => {
    //     pageData.str = val
    //     nextTick(() => {
    //       pageData.spinning = false
    //     })
    //   },
    //   { deep: true }
    // )
    return {
      ...toRefs(pageData)
    }
  }
})
